import React, { useEffect } from "react";

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  exhibitId: string;
  templateName: string;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({
  isOpen,
  onClose,
  exhibitId,
  templateName,
}) => {
  const previewUrl = `${window.location.origin}/${exhibitId}`;

  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="preview-modal-overlay" onClick={onClose}>
      <div
        className="preview-modal"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {/* Header */}
        <div className="preview-modal-header">
          <button
            className="preview-close-btn"
            onClick={onClose}
            aria-label="Close preview"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="preview-modal-title">
            <h2>Preview: {templateName}</h2>
          </div>
        </div>

        {/* Preview Content */}
        <div className="preview-modal-content">
          <div className="preview-iframe-container">
            <div
              style={{
                width: "475px",
                height: "100%",
                margin: "0 auto",
                padding: "10px",
                // border: "1px solid #ccc",
                // borderRadius: "20px",
                // overflow: "hidden",
                // boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
                // background: "#fff",
                position: "relative",
                maxWidth: "100%",
              }}
            >
              <iframe
                src={previewUrl}
                title={`${templateName} Preview`}
                className="preview-iframe"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                  background: "#fff",
                }}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="preview-modal-footer">
          <button
            className="preview-fullscreen-btn"
            onClick={() => window.open(previewUrl, "_blank")}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3H5C3.89543 3 3 3.89543 3 5V8M21 8V5C21 3.89543 20.1046 3 19 3H16M16 21H19C20.1046 21 21 20.1046 21 19V16M8 21H5C3.89543 21 3 20.1046 3 19V16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Open in New Tab
          </button>
        </div>
      </div>
    </div>
  );
};
